import type { GuideTourTrackingSnapshot } from './types'
export { buildGuideTourTrackingSnapshot } from './utils'

export type { GuideTourTrackingSnapshot } from './types'

let activeContext: GuideTourTrackingSnapshot | null = null

export const getGuideTourTrackingSnapshot = () => activeContext

export const setGuideTourTrackingSnapshot = (
  context: GuideTourTrackingSnapshot
): void => {
  activeContext = context
}

export const clearGuideTourTrackingSnapshot = (): void => {
  activeContext = null
}
